import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import OnboardingAboutMe from '../onboarding/OnboardingAboutMe';
import {
  BodyText,
  Stack,
  Touchable,
} from '../../../ui';
import AboutMe from './AboutMe';

export type EditableAboutMeProps = {
  blurb?: string;
  onEdit: () => void;
  expandable?: boolean;
  centered?: boolean;
  withHeader?: boolean;
};

const EditableAboutMe: React.FCWithChildren<EditableAboutMeProps> = ({
  blurb,
  onEdit,
  expandable = false,
  centered = false,
  withHeader = false,
}) => (blurb ? (
  <Stack space={8} alignItems={centered ? 'center' : undefined}>
    <AboutMe
      blurb={blurb}
      expandable={expandable}
      centered={centered}
      withHeader={withHeader}
    />
    <Inline>
      <Touchable
        onClick={onEdit}
        testID="editAboutMeLink"
      >
        <Box paddingY={8}>
          <BodyText
            appearance="smaller"
            color={BrandColor.FloraDark}
            textTransform="uppercase"
            weight="bold"
          >
            Edit About Me
          </BodyText>
        </Box>
      </Touchable>
    </Inline>
  </Stack>
)
  : (
    <OnboardingAboutMe onEdit={onEdit} />
  ));

export default EditableAboutMe;
